import { render } from "./docs_kyc_form.vue?vue&type=template&id=cd27d0cc"
import script from "./docs_kyc_form.vue?vue&type=script&lang=js"
export * from "./docs_kyc_form.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__